var Backbone = require('backbone');
var Marionette = require('backbone.marionette');

var Radio = require('backbone.radio');
var services = Radio.channel('services');
var notificationsChannel = Radio.channel('notifications');
var actionsChannel = Radio.channel('actions');

var CommonUtils = require('../../utils/common-utils.js');

var PatientDicomRow = Marionette.View.extend({
    tagName: 'tr',
    template: require('../../templates/medicals/patient-dicom-row.html'),
    templateContext: function () {
        var that = this;
        var studyDateTime = that.model.get('date');
        console.log(that.model.get('physicianName'));
        return {
            studyId: that.model.get('id'),
            physicianName: that.model.get('physicianName'),
            studyDate: !_.isNaN(studyDateTime) && !_.isNull(studyDateTime) && studyDateTime != '' ? that.untils.longToDateTimeFormatted(studyDateTime, "MM/DD/YYYY mm:hh") : '-'
        }
    },
    initialize: function () {
        this.untils = new CommonUtils();
    }
});

var EmptyView = Marionette.View.extend({
    tagName: 'tr',
    template: _.template(_.reduce(_.map(_.range(3), function (value) {
        return '<td>-</td>'
    }), function (memo, str) {
        return memo + str;
    }, ""))
});

var PatientDicomsTableBody = Marionette.CollectionView.extend({
    tagName: 'tbody',
    childView: PatientDicomRow,
    emptyView: EmptyView,

    collectionEvents: {},

    childViewEvents: {},

    initialize: function (options) {
        this.collection = options.collection;
    },

});

var PatientDicoms = Marionette.View.extend({
    template: require("../../templates/medicals/patient-dicoms.html"),
    regions: {
        body: {
            el: 'tbody',
            replaceElement: true
        }
    },
    initialize: function (options) {
        this.patient = _.omit(options.patient, "@class");
        this.name = options.name;
        this.collection = new Backbone.Collection();
    },

    onRender: function () {
        var that = this;
        that.showChildView('body', new PatientDicomsTableBody({
            collection: that.collection
        }));

        that.asyncDicomsRequests(that.collection, that.patient);
    },

    asyncDicomsRequests: function (collection, patient) {
        $.ajax({
            type: "get",
            url: "/api/dicom/" + patient.login,
            statusCode: {
                200: function (studies) {
                    console.log(studies);
                    if (_.isArray(studies)) {
                        studies.forEach(function (study) {
                            collection.add(new Backbone.Model(study));
                        });
                    }
                },
                503: function (e) {
                    notificationsChannel.request('show:notification', e.responseJSON);
                },
                401: function (e) {
                    actionsChannel.request("redirect:to:login");
                }
            },
            error: function (e) {
                console.log(e);
            }
        });
    }
});

module.exports = PatientDicoms;


//////////////////
// WEBPACK FOOTER
// ./app/views/medicals/patient-dicoms-view.js
// module id = 378
// module chunks = 0